import React from "react";
import InstanceSchool from "../intanceColegios";
import { AxiosError } from "axios";

export const getAllSchoolParams = async (params: any): Promise<any[]> => {
  try {
    const schools = await InstanceSchool.get("/colegios", { params });
    return schools.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    throw axiosError?.response?.data || new Error("Error desconocido");
  }
};
